module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamond.4aa7fa8.jpg";